// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// API
import { getExamAccessInfo } from "../../api";

export const useExamAccessInfo = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();

  return useMutation({
    mutationFn: async (params: {
      patientId: string;
      examId: string;
      fileType: string;
    }) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        const controller = new AbortController();
        return getExamAccessInfo(
          token,
          clinicId,
          params.patientId,
          params.examId,
          params.fileType,
          controller.signal
        );
      } catch (error) {
        throw error;
      }
    },
    // Invalidate query cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({ queryKey: ["exam-access-info"] });
    },
  });
};
